import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

class SideBar extends Component {
  closeNav = () => {
    if (document.getElementById("mySidenav")) {
      document.getElementById("mySidenav").style.width = "0";
    }
  };

  render() {
    return (
      <div id="mySidenav" className="sidenav">
        <a href="#" className="closebtn" onClick={this.closeNav}>
          &times;
        </a>
        <div id="accordion">
          <div className="side_box">
            <Link
              className="side_txt"
              to="/finance/dashboard"
              onClick={this.closeNav}
            >
              Dashboard
            </Link>

            <a
              className="dropdown-btn side_txt"
              data-toggle="collapse"
              href="#collapseOne"
            >
              Reports
              <i className="fa fa-caret-down"></i>
            </a>
            <div
              className="dropdown-container"
              id="collapseOne"
              class="collapse"
              data-parent="#accordion"
            >
              <Link
                className="side_txt active"
                to="../finance/viewConsultations"
                onClick={this.closeNav}
              >
                Consultations
              </Link>
              <Link
                className="side_txt active"
                to="/finance/DiagnosisViewOrders"
                onClick={this.closeNav}
              >
                Diagnostics
              </Link>
              <Link
                className="side_txt active"
                to="../finance/Vieworders"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-dashboard"></i> */}
                Orders Medicine
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SideBar);
